module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hans/3-87eae43aa3c558e5655e5fc4130bac74.jpg";